export default {
  title: 'Aggiorna profilo {{name}}',
  form: {
    name: {
      label: 'Nome',
      placeholder: 'Inserisci il nome completo del titolare',
    },
    email: {
      label: 'Email',
      placeholder: "Inserisci l'email personale del titolare",
      tooltip: 'Email personale del titolare/gestore del ristorante. Usata come accesso alla dashboard',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
  },
};
